import _ from "lodash";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  PlayArrow as PlayArrowIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  FiberManualRecord as FiberManualRecordIcon,
  Mic as MicIcon,
  MicOff as MicOffIcon,
  AddOutlined as AddOutlineIcon,
  RemoveOutlined as RemoveOutlineIcon,
  Favorite as Heart,
  Add as AddIcon,
  EditOutlined as EditIcon,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
} from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";
import { useReactMediaRecorder } from "react-media-recorder";
import {
  getMetadata as getVideoMetadata,
} from "video-metadata-thumbnails";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { matchPath } from "react-router";
import { useNavigate } from "react-router-dom";
import { arrayMoveImmutable } from "array-move";
import { withStyles } from "@material-ui/core/styles";
import ColorPicker from "material-ui-color-picker";
import Webcam from "react-webcam";
import { VIDEO_PREVIEW_FLAG } from "../../../types/videoStudio.types";

import SaveVideoModal from "./SaveVideoModal";
import SettingsModal from "../components/SettingsModal";
import PromptEnableCameraModal from "./PromptEnableCameraModal";
import ScriptEditorModal from "../components/PromtScriptEditorModal";
import PromptEnableMicrophoneModal from "./PromptEnableMicrophoneModal";
import { ReactComponent as VideoModalGraphic } from "../../../assets/svg/media-disabled.svg";
import { ReactComponent as ExportIcon } from "../../../assets/svg/export.svg";
import { ReactComponent as CamVideoIcon } from "../../../assets/svg/cam-video.svg";
import { ReactComponent as PersonIcon } from "../../../assets/svg/person.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svg/download.svg";
import { Button, FlashMessage, ListItem } from "../../../components/common";
import { uuid, downloadFile, getAPIEndPoint } from "../../../utils/helper";
import { createVideoRequest } from "../../../reducers/candidate/videoStudio.reducer";
import appRoutes from "../../../routes/app.routes";
import {
  VIDEO_STUDIO_FILE_ADD_LIMIT,
  MIN_VIDEO_DURATION_SEC,
  FINAL_VIDEO_DURATION_LIMIT,
  VIDEO_MAX_DURATION_SEC,
  bytesMb,
} from "../../../utils/appConstants";
import VideoTrimModal from "./VideoTrimModal";
import VideoPreviewModal from "./VideoPreviewModal";
import VideoEditLoadingModal from "./VideoEditLoadingModal";
import videoStudioServices from "../../../services/videoStudio.services";
import { rootReducersState } from "../../../reducers";
import Tooltip from "@material-ui/core/Tooltip";
import ThumbnailItem from "./ThumbnailItem";
import {
  appendTimelineClipsToFormData,
  buildTimelineMergePayload,
  generateTimelineThumbnails,
  getClipVideoDuration,
  getRemainingVideoDurationSec,
  getTimelineTotalSeconds,
  getVideoClipDuration,
  getVideoClipTimelineWidthPercent,
  getVideoDurationLimitMessage,
  isSupportedVideoUpload,
  isWithinVideoDurationLimit,
  wouldExceedVideoDurationLimit,
} from "../videoStudioTimeline.utils";

interface ICheckPermission {
  showModal?: boolean;
}

enum VIDEO_STATE {
  RECORDING_STOPPED = "recording_stopped",
  RECORDING_PAUSED = "recording_paused",
  PLAYING_STOPPED = "playing_stopped",
  RECORDING = "recording",
  PLAYING = "playing",
  IDLE = "idle",
}

enum TEXT_ALIGN {
  TEXT_CENTER = "center",
  TEXT_LEFT = "left",
  TEXT_RIGHT = "right",
}

const defaultText = "";
let abortFetchFlag: VIDEO_PREVIEW_FLAG = VIDEO_PREVIEW_FLAG.IDLE; // was not able to get updated state hence took manual variable outside of the function
let videoStreaming = null;

const DarkToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#31222A",
  },
  arrow: {
    color: "#31222A",
  },
}))(Tooltip);

const CandidateCreateVideo = () => {
  const AbortVideoPreviewController = new AbortController();
  const dispatch = useDispatch();
  const addFileRef = useRef(null);
  const recordedVideo = useRef(null);
  const navigate = useNavigate();

  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const token = _.get(sessionReducer, "token", null);

  const [recordingState, setRecordingState] = useState<VIDEO_STATE>(
    VIDEO_STATE.IDLE
  );
  const [videoPreviewModalShow, setVideoPreviewModalShow] =
    useState<boolean>(false);
  const [videoPreviewModalTitle, setVideoPreviewModalTitle] =
    useState<string>("Preview Video");
  const [videoEditLoadingModalShow, setVideoEditLoadingModalShow] =
    useState<boolean>(false);
  const [videoEditLoadingModalPercentage, setVideoEditLoadingModalPercentage] =
    useState<number>(0);
  const [videoPreviewFlag, setVideoPreviewFlag] = useState<VIDEO_PREVIEW_FLAG>(
    VIDEO_PREVIEW_FLAG.IDLE
  );
  const [hasMicrophonePermission, setHasMicrophonePermission] =
    useState<any>(false);
  const [hasCameraPermission, setHasCameraPermission] = useState<any>(false);
  const [enableMicrophoneModal, setEnableMicrophoneModal] = useState(false);
  const [finalVideoDuration, setFinalVideoDuration] = useState<string>("0");
  const [videoCutModalShow, setVideoCutModalShow] = useState<boolean>(false);
  const [, setRecordedBlobBinary] = useState<any>(null);
  const [videoExportTo, setVideoExportTo] = useState<string>("profile");
  const [studioEditDetails, setStudioEditDetails] = useState<any>({});
  const [videoCancelToken, setVideoCancelToken] = useState<any>(null);
  const [saveVideoModalShow, setSaveVideoModalShow] = useState(false);
  const [settingsModalStatus, setOpenSettingsModal] = useState(false);
  const [enableCameraModal, setEnableCameraModal] = useState(false);
  const [teleprompterText, setTeleprompterText] = useState(defaultText);
  const [teleprompterTextAlign, setTeleprompterTextAlign] = useState(
    TEXT_ALIGN.TEXT_CENTER
  );
  const [teleprompterScroll, setTeleprompterScroll] = useState(false);
  const [, setVideoStreamStop] = useState<any>(null);
  const [videoPreviewBlob, setVideoPreviewBlob] = useState<Blob>();
  const [showTeleprompter, setShowTeleprompter] = useState(true);
  const [effectLogs, setEffectLogs] = useState<Array<any>>([]);
  const [studioEditMode, setStudioEditMode] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(-25);
  const [videoCutSrc, setVideoCutSrc] = useState<any>({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [colorPicked, setColorPicked] = useState("#000000");
  const [scrollSpeed, setScrollSpeed] = useState(65);
  const [speed, setSpeed] = useState(6);
  const colorPickerRef = useRef<any>();
  const timelineAtRecordStartRef = useRef(0);
  const recordingStartedAtRef = useRef<number | null>(null);

  const {
    startRecording,
    stopRecording,
    muteAudio,
    unMuteAudio,
    isAudioMuted,
    mediaBlobUrl,
  } = useReactMediaRecorder({
    video: true,
    audio: true,
    onStop: async (blobUrl: string, blob: Blob) => {
      if (blob.size > 0) {
        setRecordedBlobBinary(blob);
        const videoMetaData = await getVideoMetadata(blob);
        if (videoMetaData.duration >= MIN_VIDEO_DURATION_SEC) {
          const _uuid = uuid();
          let blobData: any = blob;
          blobData.name = `${_uuid}.mp4`;
          const _src = URL.createObjectURL(blob);

          const videoDuration: number = videoMetaData.duration;

          const videoFile = {
            source: "record",
            type: "blob",
            uuid: _uuid,
            size: blob.size,
            duration: videoDuration,
            sourceDuration: videoDuration,
            blob,
            src: _src,
          };

          setEffectLogs((prevData) => {
            if (wouldExceedVideoDurationLimit(prevData, videoDuration)) {
              FlashMessage(getVideoDurationLimitMessage(), "error");
              return prevData;
            }

            return [...prevData, videoFile];
          });

          generateTimelineThumbnails(blob, videoDuration).then((thumbnails) => {
            setEffectLogs((prevData) => {
              if (!prevData.some((row) => row.uuid === _uuid)) {
                return prevData;
              }

              return [...prevData].map((row) => {
                if (row.uuid === _uuid) {
                  return { ...row, thumbnails: thumbnails };
                }
                return row;
              });
            });
          });
        } else {
          FlashMessage(
            `Minimum duration must be ${MIN_VIDEO_DURATION_SEC}sec`,
            "error"
          );
        }
      }
    },
  });

  // Hook, did mount
  useEffect(() => {
    // Add video play and pause add event listener
    setTimeout(() => {
      if (recordedVideo.current) {
        recordedVideo.current.addEventListener("playing", () => {
          setRecordingState(VIDEO_STATE.PLAYING);
        });
        recordedVideo.current.addEventListener("ended", () => {
          setRecordingState(VIDEO_STATE.RECORDING_STOPPED);
        });
        recordedVideo.current.addEventListener("pause", () => {
          setRecordingState(VIDEO_STATE.RECORDING_STOPPED);
        });
      }
    }, 3000);

    // Get video details if in edit mode
    fetchVideoStudioEditMode();

    checkVideoRecordPermissions();

    return () => {
      try {
        if (videoStreaming) {
          videoStreaming.getTracks().forEach((track) => {
            track.stop();
          });
        }
      } catch (error) {
        console.log({ error });
      }
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (recordingState !== VIDEO_STATE.RECORDING) {
      recordingStartedAtRef.current = null;
      return;
    }

    recordingStartedAtRef.current = Date.now();

    const intervalId = window.setInterval(() => {
      if (recordingStartedAtRef.current == null) {
        return;
      }

      const elapsedSec =
        (Date.now() - recordingStartedAtRef.current) / 1000;

      if (
        timelineAtRecordStartRef.current + elapsedSec >=
        FINAL_VIDEO_DURATION_LIMIT
      ) {
        setRecordingState(VIDEO_STATE.RECORDING_STOPPED);
        stopRecording();
        setTeleprompterScroll(false);
        FlashMessage(
          `Maximum ${VIDEO_MAX_DURATION_SEC} seconds reached`,
          "error"
        );
      }
    }, 250);

    return () => window.clearInterval(intervalId);
  }, [recordingState, stopRecording]);

  // Fetch and set video studio
  const fetchVideoStudioEditMode = async () => {
    // const matchRoute = matchPath(window.location.pathname, {
    //   path: appRoutes.candidateEditVideo.path,
    //   exact: true,
    //   strict: false,
    // });
    const matchRoute = matchPath(
  { path: appRoutes.candidateEditVideo.path, end: true },
  window.location.pathname
);

    const videoId = _.get(matchRoute, "params.id", 0);

    // Check if candidate is on edit page
    if (videoId) {
      try {
        // Fetch and check if video is available
        const result = await videoStudioServices.fetchVideoDetails(videoId);

        if (_.get(result, "data.data.id", 0)) {
          const data = _.get(result, "data.data", {});
          setStudioEditMode(true);
          setStudioEditDetails(data);

          let blobPayload: Array<any> = [];

          const studioClips = _.get(data, "videoStudioClips", []) || [];
          const clipRows =
            studioClips.length > 0
              ? studioClips
              : data.video_file
                ? [{ id: 0, video_file: data.video_file }]
                : [];

          clipRows.forEach((row) => {
            blobPayload.push({
              uuid: uuid(),
              videoStudioId: parseInt(videoId, 10),
              clipId: row.id,
              fileName: row.video_file,
            });
          });

          if (blobPayload.length === 0) {
            FlashMessage("No video clips found to edit", "error");
            navigate(appRoutes.candidateVideos.path);
            return;
          }

          setEffectLogs(blobPayload);
          const incPercent = 100 / blobPayload.length / 2;

          // Show Modal loading video
          setVideoEditLoadingModalShow(true);

          // Promise through all the API request and get the Blob file
          await Promise.all(
            blobPayload.map(async (row) => {
              try {
                const fileResult = await videoStudioServices.getClipVideoBlob({
                  videoStudioId: row.videoStudioId,
                  clipId: row.clipId,
                });

                if (_.get(fileResult, "data", null) instanceof Blob) {
                  let blobData: any = _.get(fileResult, "data");
                  blobData.name = row.fileName;

                  const videoMetaData = await getVideoMetadata(blobData);
                  const _src = URL.createObjectURL(blobData);
                  const videoDuration: number = videoMetaData.duration;

                  const _uuid = row.uuid;
                  const videoFile = {
                    source: "upload",
                    type: "blob",
                    uuid: _uuid,
                    size: blobData.size,
                    duration: videoDuration,
                    sourceDuration: videoDuration,
                    blob: blobData,
                    src: _src,
                    videoStudioId: row.videoStudioId,
                    clipId: row.clipId,
                  };

                  setEffectLogs((prevData) => {
                    return [...prevData].map((row) => {
                      if (row.uuid === _uuid) {
                        return videoFile;
                      } else {
                        return row;
                      }
                    });
                  });

                  // Increment percentage
                  setVideoEditLoadingModalPercentage(
                    (prevPercentage) => prevPercentage + incPercent
                  );

                  generateTimelineThumbnails(blobData, videoDuration).then(
                    (thumbnails) => {
                      setEffectLogs((prevData) => {
                        return [...prevData].map((row) => {
                          if (row.uuid === _uuid) {
                            return { ...row, thumbnails: thumbnails };
                          }
                          return row;
                        });
                      });

                      setVideoEditLoadingModalPercentage(
                        (prevPercentage) => prevPercentage + incPercent
                      );
                    }
                  );

                  return true;
                } else {
                  return false;
                }
              } catch (error) {
                return false;
              }
            })
          );
          setVideoEditLoadingModalShow(false);
        } else {
          FlashMessage("No video found", "error");
          navigate(appRoutes.candidateVideos.path);
        }
      } catch (error) {
        console.log("error", error.message);
      }
    }
  };

  const showEditModal = () => {
    setOpenEditModal(true);
    setShowTeleprompter(true);
  };

  /**
   * Check require permission before start the recording
   *
   */
  const checkVideoRecordPermissions = async (
    options: ICheckPermission = {}
  ): Promise<boolean> => {
    // Check camera permissions
    try {
      const cameraPermission = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      if (cameraPermission.active === true) {
        videoStreaming = cameraPermission;
        setVideoStreamStop(cameraPermission);
        setHasCameraPermission(true);
      } else {
        if (options.showModal === true) {
          setEnableCameraModal(true);
        }

        setHasCameraPermission(false);
        return false;
      }
    } catch (error) {
      if (options.showModal === true) {
        setEnableCameraModal(true);
      }

      setHasCameraPermission(false);
      return false;
    }

    // Check auto permissions
    try {
      const microphonePermission = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      if (microphonePermission.active === true) {
        setHasMicrophonePermission(true);
      } else {
        if (options.showModal === true) {
          setEnableMicrophoneModal(true);
        }

        setHasMicrophonePermission(false);
        return false;
      }
    } catch (error) {
      if (options.showModal === true) {
        setEnableMicrophoneModal(true);
      }

      setHasMicrophonePermission(false);
      return false;
    }

    return true;
  };

  const startPauseRecording = async () => {
    const hasPermission = await checkVideoRecordPermissions({
      showModal: true,
    });

    if (effectLogs.length < VIDEO_STUDIO_FILE_ADD_LIMIT) {
      if (hasPermission) {
        if (
          recordingState === VIDEO_STATE.RECORDING_STOPPED ||
          recordingState === VIDEO_STATE.IDLE
        ) {
          const remainingDuration = getRemainingVideoDurationSec(effectLogs);

          if (remainingDuration <= 0) {
            FlashMessage(getVideoDurationLimitMessage(), "error");
            return;
          }

          if (remainingDuration < MIN_VIDEO_DURATION_SEC) {
            FlashMessage(
              `Not enough time remaining to record. Maximum video length is ${VIDEO_MAX_DURATION_SEC} seconds.`,
              "error"
            );
            return;
          }

          timelineAtRecordStartRef.current =
            getTimelineTotalSeconds(effectLogs);
          setRecordingState(VIDEO_STATE.RECORDING);
          startRecording();
          setTeleprompterScroll(true);
        } else if (recordingState === VIDEO_STATE.RECORDING) {
          setRecordingState(VIDEO_STATE.RECORDING_STOPPED);
          stopRecording();
          setTeleprompterScroll(false);
        }
      }
    } else {
      FlashMessage(
        `Max ${VIDEO_STUDIO_FILE_ADD_LIMIT} videos are allow`,
        "error"
      );
    }
  };

  const playPauseVideo = () => {
    if (recordedVideo) {
      if (recordingState === VIDEO_STATE.PLAYING) {
        setRecordingState(VIDEO_STATE.RECORDING_STOPPED);
        recordedVideo.current.pause();
      } else {
        setRecordingState(VIDEO_STATE.PLAYING);
        recordedVideo.current.play();
      }
    }
  };

  const getAudioPermissions = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        console.log("Audio permissions: OK");
      })
      .catch((reason) => {
        FlashMessage(
          "Permission denied, Please enabled microphone permission from browser",
          "error"
        );
      });
  };

  const getCameraPermissions = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        console.log("Video permissions: OK");
        setVideoStreamStop(stream);
      })
      .catch((reason) => {
        FlashMessage(
          "Permission denied, Please enabled camera permission from browser",
          "error"
        );
      });
  };

  const increaseSpeed = () => {
    setSpeed((prevCount) => prevCount + 1);
    scrollSpeed === 5
      ? setScrollSpeed(scrollSpeed)
      : setScrollSpeed((prevCount) => prevCount - 10);
    setScrollPosition((prevCount) => prevCount + 5);
  };

  const decreaseSpeed = () => {
    setSpeed((prevCount) => prevCount - 1);
    setScrollSpeed((prevCount) => prevCount + 10);
    setScrollPosition((prevCount) => prevCount - 5);
  };

  const setTelePromptData = (data) => {
    // const teleprompterText = (data || "").replace(/<\/?[^>]+(>|$)/g, "");
    setTeleprompterText(data);
    setOpenEditModal(false);
  };

  const smDashes: any[] = [];

  for (let i = 0; i < 20; i++) {
    smDashes.push(<div className="sm-dash" />);
  }

  const muteUnmuteMic = (): void => {
    if (isAudioMuted) {
      unMuteAudio();
    } else {
      muteAudio();
    }
  };

  const exportToProfile = (data: any = {}) => {
    if (effectLogs.length > 0) {
      const formData = new FormData();
      const { videoMetaData } = buildTimelineMergePayload(effectLogs);
      const totalSeconds = getTimelineTotalSeconds(effectLogs);

      appendTimelineClipsToFormData(formData, effectLogs);
      formData.append("videoMeta", JSON.stringify(videoMetaData));

      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("exportTo", videoExportTo || "profile");

      if (isWithinVideoDurationLimit(totalSeconds)) {
        // Generate cancel token and send it
        const cancelToken = axios.CancelToken.source();
        setVideoCancelToken(cancelToken);

        if (studioEditMode) {
          dispatch(
            createVideoRequest({
              formData,
              cancelToken,
              id: studioEditDetails.id,
            })
          );
        } else {
          dispatch(createVideoRequest({ formData, cancelToken }));
        }
      } else {
        FlashMessage(getVideoDurationLimitMessage(), "error");
      }
    } else {
      FlashMessage("Add recorded or uploaded clips to the timeline first", "error");
    }
  };

  const _handleCloseSaveVideoModal = () => {
    setSaveVideoModalShow(false);

    if (videoCancelToken && typeof videoCancelToken.cancel === "function") {
      videoCancelToken.cancel();
    }
  };

  const showExportToProfileModal = (exportTo = "profile") => {
    // Return if video process is already running
    if ([VIDEO_STATE.RECORDING, VIDEO_STATE.PLAYING].includes(recordingState)) {
      return false;
    }

    if (effectLogs.length > 0) {
      const totalSeconds = getTimelineTotalSeconds(effectLogs);

      if (!isWithinVideoDurationLimit(totalSeconds)) {
        FlashMessage(getVideoDurationLimitMessage(), "error");
        return;
      }

      setFinalVideoDuration(Math.floor(totalSeconds).toFixed(0));

      setVideoExportTo(exportTo);
      setSaveVideoModalShow(true);
    } else {
      FlashMessage("Add recorded or uploaded clips to the timeline first", "error");
    }
  };

  const _handleOpenFileDialog = () => {
    if (effectLogs.length < VIDEO_STUDIO_FILE_ADD_LIMIT) {
      const click = _.get(addFileRef, "current.click", null);

      if (typeof click === "function" && addFileRef) {
        addFileRef?.current?.click();
      }
    } else {
      FlashMessage(
        `Max ${VIDEO_STUDIO_FILE_ADD_LIMIT} videos are allow`,
        "error"
      );
    }
  };

  const handleFileUpload = async (e) => {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      FlashMessage("Please select file to upload", "error");
      return;
    }

    try {
      if (!isSupportedVideoUpload(file)) {
        FlashMessage("Upload valid mp4 or mov video file", "error");
        return;
      }

      if (file.size > bytesMb.mb_50 || file.size <= 0) {
        FlashMessage("File size should be 50MB or less", "error");
        return;
      }

      const videoDuration = await getClipVideoDuration(file);

      if (!Number.isFinite(videoDuration) || videoDuration <= 0) {
        FlashMessage("Unable to read video duration", "error");
        return;
      }

      if (videoDuration < MIN_VIDEO_DURATION_SEC) {
        FlashMessage(
          `Minimum duration must be ${MIN_VIDEO_DURATION_SEC}sec`,
          "error"
        );
        return;
      }

      if (wouldExceedVideoDurationLimit(effectLogs, videoDuration)) {
        FlashMessage(getVideoDurationLimitMessage(), "error");
        return;
      }

      const _uuid = uuid();
      const _src = URL.createObjectURL(file);

      const videoFile = {
        source: "upload",
        type: "blob",
        uuid: _uuid,
        size: file.size,
        duration: videoDuration,
        sourceDuration: videoDuration,
        blob: file,
        src: _src,
      };

      setEffectLogs((prevData) => [...prevData, videoFile]);

      generateTimelineThumbnails(file, videoDuration)
        .then((thumbnails) => {
          setEffectLogs((prevData) =>
            prevData.map((row) =>
              row.uuid === _uuid ? { ...row, thumbnails } : row
            )
          );
        })
        .catch((error) => {
          console.log({ error });
        });
    } catch (error) {
      FlashMessage(
        _.get(error, "message", "Unable to process uploaded video"),
        "error"
      );
    } finally {
      input.value = "";
    }
  };

  const _handleOnDeleteAddedFiles = (effect) => {
    if (!effect?.uuid) {
      return;
    }

    if (typeof effect.src === "string" && effect.src.startsWith("blob:")) {
      URL.revokeObjectURL(effect.src);
    }

    if (videoCutSrc?.uuid === effect.uuid) {
      setVideoCutModalShow(false);
      setVideoCutSrc({});
    }

    const newData = effectLogs.filter((row) => row.uuid !== effect.uuid);
    setEffectLogs(newData);

    if (newData.length === 0) {
      setRecordingState(VIDEO_STATE.IDLE);
    }
  };

  const _handleShowVideoCutModal = (effect) => {
    setVideoCutSrc(effect);
    setVideoCutModalShow(true);
  };

  const SortableItem = SortableElement(({ effect }) => (
    <ThumbnailItem
      key={effect.uuid}
      effect={effect}
      widthPercent={getVideoClipTimelineWidthPercent(getVideoClipDuration(effect))}
      _handleOnDeleteAddedFiles={_handleOnDeleteAddedFiles}
      _handleShowVideoCutModal={_handleShowVideoCutModal}
    />
  ));

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div className={`vs-video-sections ${items.length === 0 && "p-all-0"}`}>
        {items.map((effect, index) => (
          <SortableItem key={effect.uuid || `item-${index}`} index={index} effect={effect} />
        ))}
      </div>
    );
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newData = arrayMoveImmutable([...effectLogs], oldIndex, newIndex);
    setEffectLogs(newData);
  };

  const _handleOnVideoCut = async (effect) => {
    const startTime = _.get(effect, "metaData.startTime", 0);
    const endTime = _.get(effect, "metaData.endTime", effect.duration || 0);
    const clipDuration = Math.max(0, endTime - startTime);
    const source = effect.blob;

    if (source && clipDuration > 0) {
      const otherClips = effectLogs.filter((row) => row.uuid !== effect.uuid);
      const trimmedTotal = getTimelineTotalSeconds([
        ...otherClips,
        { ...effect, duration: clipDuration },
      ]);

      if (!isWithinVideoDurationLimit(trimmedTotal)) {
        FlashMessage(getVideoDurationLimitMessage(), "error");
        return;
      }

      setEffectLogs((prevState) =>
        prevState.map((row) =>
          row.uuid === effect.uuid
            ? {
                ...effect,
                duration: clipDuration,
                thumbnails: undefined,
                metaData: {
                  ...effect.metaData,
                  startTime,
                  endTime,
                  thumbStartTime: startTime,
                  thumbEndTime: endTime,
                  sourceDuration:
                    effect.sourceDuration ??
                    effect.metaData?.sourceDuration ??
                    effect.duration,
                },
              }
            : row
        )
      );

      try {
        const thumbnails = await generateTimelineThumbnails(
          source,
          clipDuration,
          startTime
        );

        setEffectLogs((prevState) =>
          prevState.map((row) =>
            row.uuid === effect.uuid ? { ...row, thumbnails } : row
          )
        );
      } catch (error) {
        console.log({ error });
        FlashMessage("Unable to refresh clip thumbnails after trim", "error");
      }

      return;
    }

    setEffectLogs((prevState) => {
      return prevState.map((row) => {
        if (row.uuid === effect.uuid) {
          return {
            ...effect,
            duration: clipDuration,
            metaData: {
              ...effect.metaData,
              startTime,
              endTime,
              thumbStartTime: startTime,
              thumbEndTime: endTime,
              sourceDuration:
                effect.sourceDuration ??
                effect.metaData?.sourceDuration ??
                effect.duration,
            },
          };
        }
        return row;
      });
    });
  };

  let abortControllerInterval;

  const _handlePreviewDownloadVideo = (type: string) => {
    // Return if video process is already running
    if ([VIDEO_STATE.RECORDING, VIDEO_STATE.PLAYING].includes(recordingState)) {
      return false;
    }

    if (effectLogs.length > 0) {
      const formData = new FormData();
      const { videoMetaData } = buildTimelineMergePayload(effectLogs);
      const totalSeconds = getTimelineTotalSeconds(effectLogs);

      appendTimelineClipsToFormData(formData, effectLogs);
      formData.append("videoMeta", JSON.stringify(videoMetaData));

      // Check if the video is more than valid seconds, if not return the user before even showing preview
      if (!isWithinVideoDurationLimit(totalSeconds)) {
        FlashMessage(getVideoDurationLimitMessage(), "error");
        return;
      }

      // Submit a form
      setVideoPreviewModalTitle(
        type === "download" ? "Download Video" : "Preview Video"
      );
      setVideoPreviewModalShow(true);
      setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.INPROGRESS);

      let httpHeader = new Headers();
      httpHeader.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "POST",
        headers: httpHeader,
        body: formData,
        signal: AbortVideoPreviewController.signal,
      };

      fetch(getAPIEndPoint("video-studio/preview-video"), requestOptions)
        .then((response) =>
          response.status === 200 ? response.blob() : response.json()
        )
        .then((result) => {
          console.log(result,"result");
          if (result instanceof Blob) {
            if (type === "download") {
              setVideoPreviewModalShow(false);
              const fileName = `eh-studio-${uuid()}.mp4`;
              downloadFile(fileName, result);
              setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.DONE_DOWNLOAD);
            } else if (type === "preview") {
              setVideoPreviewBlob(result);
              setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.DONE_PREVIEW);
            }
            abortFetchFlag = VIDEO_PREVIEW_FLAG.DONE_PREVIEW;
          } else {
            setVideoPreviewModalShow(false);
            setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.ERROR);
            FlashMessage("Error while generating preview", "error");
            abortFetchFlag = VIDEO_PREVIEW_FLAG.ERROR;
          }
        })
        .catch((error) => {
          if (
            (error.message || "").toLowerCase().indexOf("the user aborted") > -1
          ) {
            setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.ABORT);
            setVideoPreviewModalShow(false);
          } else {
            setVideoPreviewFlag(VIDEO_PREVIEW_FLAG.ERROR);
            FlashMessage(
              `${error.message || "Error while generating preview"}`,
              "error"
            );
          }
          abortFetchFlag = VIDEO_PREVIEW_FLAG.ERROR;
        });
    } else {
      abortFetchFlag = VIDEO_PREVIEW_FLAG.ERROR;
      FlashMessage(`At least 1 video required to ${type}`, "error");
    }

    abortControllerInterval = setInterval(() => {
      if ([VIDEO_PREVIEW_FLAG.MANUAL_ABORT].includes(abortFetchFlag)) {
        AbortVideoPreviewController.abort();
        abortFetchFlag = VIDEO_PREVIEW_FLAG.IDLE;
        clearInterval(abortControllerInterval);
      } else if (
        [
          VIDEO_PREVIEW_FLAG.DONE_PREVIEW,
          VIDEO_PREVIEW_FLAG.DONE_DOWNLOAD,
          VIDEO_PREVIEW_FLAG.ERROR,
        ].includes(abortFetchFlag)
      ) {
        abortFetchFlag = VIDEO_PREVIEW_FLAG.IDLE;
        clearInterval(abortControllerInterval);
      }
    }, 500);
  };

  const _handleCloseVideoPreviewModal = (action: string) => {
    // Check current status of video preview and abort it if status is in progress
    if (VIDEO_PREVIEW_FLAG.INPROGRESS === videoPreviewFlag) {
      abortFetchFlag = VIDEO_PREVIEW_FLAG.MANUAL_ABORT;
    } else {
      // Hide the modal
      setVideoPreviewModalShow(false);

      if (action === "save") {
        if (studioEditMode) {
          showExportToProfileModal("update");
        } else {
          showExportToProfileModal("studio");
        }
      }
    }
  };

  const LeftNavItems = [
    {
      id: 1,
      title: (
        <p>
          <div className="circle">
            <Heart />
          </div>
          eH Studio {studioEditMode ? "Edit" : "New Draft"}
        </p>
      ),
    },
    {
      id: 2,
      title: (
        <p>
          <ExportIcon /> Export
        </p>
      ),
      subItems: [
        {
          id: 1,
          title: (
            <p>
              <CamVideoIcon /> To Studio
            </p>
          ),
          onClick: () => {
            showExportToProfileModal("studio");
          },
        },
        {
          id: 2,
          title: (
            <p>
              <PersonIcon /> To Profile
            </p>
          ),
          onClick: () => {
            showExportToProfileModal("profile");
          },
        },
        {
          id: 3,
          title: (
            <p>
              <DownloadIcon /> Download
            </p>
          ),
          onClick: () => {
            _handlePreviewDownloadVideo("download");
          },
        },
      ],
    },
  ];

  return (
    <>
      <div className="create-video-background">
        <div className="only-for-mobile">
          <h3>Video studio works with ipad or desktop screen devices only.</h3>
          <div
            onClick={() => {
              navigate(appRoutes.candidateVideos.path);
            }}
            className="back-btn"
          >
            <div className="triangle-left" />
            <p>Back</p>
          </div>
        </div>
        <div className="page-wrapper">
          <div className="video-left-wrap">
            <ListItem items={LeftNavItems} />
            <div
              onClick={() => {
                navigate(appRoutes.candidateVideos.path);
              }}
              className="back-btn"
            >
              <div className="triangle-left" />
              <p>Back</p>
            </div>
          </div>
          <div className="video-center-wrap">
            <div className="create-video-wrapper">
              <div className="vs-header">
                <Button
                  onClick={(e) => showEditModal()}
                  startIcon={<EditIcon />}
                  className="vs-header-edit-btn"
                  color="secondary"
                  disabled={[
                    VIDEO_STATE.RECORDING,
                    VIDEO_STATE.PLAYING,
                  ].includes(recordingState)}
                >
                  EDIT TELEPROMPTER
                </Button>
                <Button
                  onClick={() => setShowTeleprompter(!showTeleprompter)}
                  startIcon={
                    showTeleprompter ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )
                  }
                  className="vs-header-teleprompter-btn"
                >
                  {showTeleprompter ? "HIDE" : "SHOW"} TELEPROMPTER
                </Button>
              </div>
              <div className="vs-content">
                <div className="vs-main-content-wrapper">
                  {hasCameraPermission === true &&
                    hasMicrophonePermission === true &&
                    showTeleprompter ? (
                    <div className="vs-container tele-script-container">
                      <div
                        className="tele-script slim-scrollbar"
                        style={{
                          animation: teleprompterScroll
                            ? `tele-script ${scrollSpeed}s linear normal`
                            : "none",
                          animationDelay: teleprompterScroll
                            ? `${scrollPosition}s`
                            : "none",
                          color: colorPicked,
                          textAlign: teleprompterTextAlign,
                        }}
                      >
                        {teleprompterText ? (
                          <div
                            className="tele-text-color wysiwyg-data"
                            dangerouslySetInnerHTML={{
                              __html: teleprompterText,
                            }}
                          />
                        ) : (
                          <span
                            className="cursor-pointer"
                            onClick={() => showEditModal()}
                          >
                            <p>Add Your</p>
                            <p className="mt-3">Teleprompter Script</p>
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}

                  {hasCameraPermission === true &&
                    hasMicrophonePermission === true && (
                      <>
                        <video
                          className={
                            [
                              VIDEO_STATE.RECORDING_STOPPED,
                              VIDEO_STATE.PLAYING,
                            ].includes(recordingState)
                              ? "recorded-video"
                              : "hide"
                          }
                          ref={recordedVideo}
                          src={mediaBlobUrl}
                          // controls
                        />
                        {[VIDEO_STATE.IDLE, VIDEO_STATE.RECORDING].includes(
                          recordingState
                        ) && (
                            <div className="teleprompter-video-div">
                              <Webcam
                                height={720}
                                className="video-display"
                                mirrored
                                videoConstraints={{
                                  width: 1280,
                                  height: 720,
                                  facingMode: "user",
                                }}
                              />
                              {recordingState === VIDEO_STATE.RECORDING && (
                                <div className="video-recording-sign">
                                  <FiberManualRecordIcon className="blinking" />
                                </div>
                              )}
                            </div>
                          )}
                      </>
                    )}

                  {(hasCameraPermission === false ||
                    hasMicrophonePermission === false) && (
                      <div className="vs-container disabled-camera-container">
                        <VideoModalGraphic />
                        <div className="disabled-camera-container-content">
                          <p>
                            You have not granted permission to use your camera and
                            microphone. Use the buttons in the browser's address
                            bar to enable all device access.
                          </p>
                        </div>
                        <div className="disabled-camera-container-buttons">
                          {hasCameraPermission === false && (
                            <Button onClick={(e) => getCameraPermissions()}>
                              ENABLE CAMERA
                            </Button>
                          )}
                          {hasMicrophonePermission === false && (
                            <Button
                              color="secondary"
                              onClick={(e) => getAudioPermissions()}
                            >
                              ENABLE MICROPHONE
                            </Button>
                          )}
                        </div>
                      </div>
                    )}
                </div>
                <div className="vs-bottom-buttons">
                  <Button
                    className="vs-button-settings btn-transparent"
                    onClick={(e) => _handlePreviewDownloadVideo("preview")}
                    disabled={[
                      VIDEO_STATE.RECORDING,
                      VIDEO_STATE.PLAYING,
                    ].includes(recordingState)}
                  >
                    <VisibilityIcon className="settings-icon" />
                    PREVIEW VIDEO
                  </Button>
                  <div className="vs-cntrl-button-wrap">
                    <Button
                      className="play-button"
                      disabled={
                        recordingState === VIDEO_STATE.RECORDING_STOPPED ||
                          recordingState === VIDEO_STATE.PLAYING
                          ? false
                          : true
                      }
                      onClick={() => playPauseVideo()}
                    >
                      {recordingState === VIDEO_STATE.PLAYING ? (
                        <PauseIcon className="pause-icon" />
                      ) : (
                        <PlayArrowIcon className="play-arrow-icon" />
                      )}
                    </Button>
                    <Button
                      className="record-button"
                      onClick={() => startPauseRecording()}
                      disabled={
                        recordingState === VIDEO_STATE.PLAYING ? true : false
                      }
                    >
                      {recordingState === VIDEO_STATE.RECORDING && (
                        <StopIcon className="stop-icon" />
                      )}
                      {(recordingState === VIDEO_STATE.RECORDING_STOPPED ||
                        recordingState === VIDEO_STATE.IDLE ||
                        recordingState === VIDEO_STATE.PLAYING) && (
                          <FiberManualRecordIcon className="record-icon" />
                        )}
                    </Button>
                    <Button
                      className="mic-button"
                      onClick={() => muteUnmuteMic()}
                      disabled={
                        recordingState === VIDEO_STATE.RECORDING ? false : true
                      }
                    >
                      {isAudioMuted === true ? (
                        <MicOffIcon className="mic-icon" />
                      ) : (
                        <MicIcon className="mic-icon" />
                      )}
                    </Button>
                  </div>
                  <input
                    className="file-upload-input"
                    ref={addFileRef}
                    onChange={(e) => handleFileUpload(e)}
                    type="file"
                    accept="video/mp4,video/quicktime,.mp4,.mov"
                  />
                  <Button
                    color="secondary"
                    className="vs-button-add-files btn-transparent"
                    onClick={() => _handleOpenFileDialog()}
                    disabled={[
                      VIDEO_STATE.RECORDING,
                      VIDEO_STATE.PLAYING,
                    ].includes(recordingState)}
                  >
                    <AddIcon className="add-icon"></AddIcon>
                    ADD FILES
                  </Button>
                </div>
              </div>
            </div>
            <div className="vs-bottom-previewer">
              <div className="ruler">
                <div className="ruler-wrapper">
                  {[0, 1, 2, 3, 4, 5].map((row) => (
                    <div className="lg-dash" key={row}>
                      {smDashes}
                    </div>
                  ))}
                  <div className="lg-dash">
                    <div className="sm-dash"></div>
                    <div className="sm-dash"></div>
                  </div>
                </div>
              </div>
              <SortableList
                distance={1}
                axis={"x"}
                items={effectLogs}
                onSortEnd={onSortEnd}
                helperClass="sortable-video"
                getHelperDimensions={({ node }) => {
                  const rect = node.getBoundingClientRect();
                  return {
                    width: rect.width,
                    height: rect.height,
                  };
                }}
                shouldCancelStart={(event) =>
                  !!(event.target as HTMLElement).closest(
                    ".timeline-clip-menu-btn, .timeline-clip-dropdown"
                  )
                }
              />
            </div>
          </div>
          <div className="video-right-wrap">
            <div className="prompt-speed-container">
              <AddOutlineIcon
                className="add-circle-icon"
                onClick={increaseSpeed}
              />
              <DarkToolTip
                title={
                  <div>
                    <p className="m-0">Prompt Speed</p>
                    <p className="m-0">(Second/Line)</p>
                  </div>
                }
                placement="left"
                arrow
              >
                <p>{speed}</p>
              </DarkToolTip>
              <RemoveOutlineIcon
                className="remove-circle-icon"
                onClick={decreaseSpeed}
              />
            </div>
            <DarkToolTip
              title={<p className="m-0">Text Color</p>}
              placement="left"
              arrow
            >
              <div
                onClick={() =>
                  colorPickerRef &&
                  colorPickerRef.current &&
                  colorPickerRef.current.click()
                }
                className="color-swatch"
                style={{ backgroundColor: colorPicked }}
              />
            </DarkToolTip>
            <ColorPicker
              inputRef={colorPickerRef}
              inputProps={{ style: { display: "none" } }}
              name="color"
              className="color-picker"
              value={colorPicked}
              onChange={setColorPicked}
            />
            <div
              className={`align ${teleprompterTextAlign === TEXT_ALIGN.TEXT_LEFT && "active"
                }`}
              onClick={() => setTeleprompterTextAlign(TEXT_ALIGN.TEXT_LEFT)}
            >
              <FormatAlignLeft />
            </div>
            <div
              className={`align ${teleprompterTextAlign === TEXT_ALIGN.TEXT_CENTER && "active"
                }`}
              onClick={() => setTeleprompterTextAlign(TEXT_ALIGN.TEXT_CENTER)}
            >
              <DarkToolTip
                title={<p className="m-0">Text Alignment</p>}
                placement="left"
                arrow
              >
                <FormatAlignCenter />
              </DarkToolTip>
            </div>
            <div
              className={`align ${teleprompterTextAlign === TEXT_ALIGN.TEXT_RIGHT && "active"
                }`}
              onClick={() => setTeleprompterTextAlign(TEXT_ALIGN.TEXT_RIGHT)}
            >
              <FormatAlignRight />
            </div>
          </div>
        </div>
      </div>

      <SettingsModal
        status={settingsModalStatus}
        handleOnClose={() => setOpenSettingsModal(false)}
      />
      <PromptEnableCameraModal
        status={enableCameraModal}
        handleOnClose={() => setEnableCameraModal(false)}
      />
      <PromptEnableMicrophoneModal
        status={enableMicrophoneModal}
        handleOnClose={() => setEnableMicrophoneModal(false)}
      />
      <SaveVideoModal
        show={saveVideoModalShow}
        videoExportTo={videoExportTo}
        finalVideoDuration={finalVideoDuration}
        studioEditDetails={studioEditDetails}
        exportToProfile={(formData) => exportToProfile(formData)}
        handleOnClose={() => _handleCloseSaveVideoModal()}
      />
      <ScriptEditorModal
        value={teleprompterText}
        status={openEditModal}
        handleOnClose={() => setOpenEditModal(false)}
        onSubmit={(data) => setTelePromptData(data)}
      />
      <VideoPreviewModal
        title={videoPreviewModalTitle}
        videoPreviewFlag={videoPreviewFlag}
        videoPreviewBlob={videoPreviewBlob as Blob}
        show={videoPreviewModalShow}
        onClose={(action: string) => _handleCloseVideoPreviewModal(action)}
      />
      <VideoEditLoadingModal
        show={videoEditLoadingModalShow}
        loadingPercentage={videoEditLoadingModalPercentage}
      />
      <VideoTrimModal
        show={videoCutModalShow}
        onClose={() => setVideoCutModalShow(false)}
        onVideoCut={(effect) => _handleOnVideoCut(effect)}
        videoSrc={videoCutSrc}
      />
    </>
  );
};

export default CandidateCreateVideo;
